// import React from "react"
// import { useState } from "react"
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   Box,
//   Typography,
//   Chip,
//   IconButton,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Alert,
//   CircularProgress,
// } from "@mui/material"
// import { Close as CloseIcon, Send as SendIcon, AttachFile as AttachFileIcon } from "@mui/icons-material"
// import styles from "./EmailComposer.module.css"

// interface EmailComposerProps {
//   open: boolean
//   onClose: () => void
//   recipients: any[]
//   onSendEmail: (emailData: any) => Promise<void>
//   project?: any
//   selectedRole?: any
// }

// const EmailComposer: React.FC<EmailComposerProps> = ({
//   open,
//   onClose,
//   recipients,
//   onSendEmail,
//   project,
//   selectedRole,
// }) => {
//   const [subject, setSubject] = useState("")
//   const [message, setMessage] = useState("")
//   const [template, setTemplate] = useState("")
//   const [sending, setSending] = useState(false)
//   const [error, setError] = useState("")

//   const position =
//     typeof selectedRole?.jobTitle === "string"
//       ? selectedRole.jobTitle
//       : selectedRole?.jobTitle?.name ||
//         (typeof project?.project_name === "string" ? project.project_name : project?.project_name?.name) ||
//         "Position"

//   const projectName =
//     typeof project?.project_name === "string" ? project.project_name : project?.project_name?.name || "Our Company"

//   const emailTemplates = {
//     interview_invitation: {
//       subject: `Interview Invitation - ${position}`,
//       body: `Dear {{name}},

// Thank you for your interest in the ${position} position at ${projectName}. We were impressed with your application and would like to invite you for an interview.

// Please let us know your availability for the coming week, and we'll schedule a convenient time.

// Best regards,
// Hiring Team`,
//     },
//     application_received: {
//       subject: `Application Received - ${position}`,
//       body: `Dear {{name}},

// Thank you for applying for the ${position} position at ${projectName}. We have received your application and will review it carefully.

// We will contact you within the next few days regarding the next steps in our hiring process.

// Best regards,
// Hiring Team`,
//     },
//     rejection: {
//       subject: `Update on Your Application - ${position}`,
//       body: `Dear {{name}},

// Thank you for your interest in the ${position} position at ${projectName} and for taking the time to apply.

// After careful consideration, we have decided to move forward with other candidates whose experience more closely matches our current needs.

// We appreciate your interest in our company and encourage you to apply for future opportunities.

// Best regards,
// Hiring Team`,
//     },
//   }

//   const handleTemplateChange = (templateKey: string) => {
//     setTemplate(templateKey)
//     if (templateKey && emailTemplates[templateKey as keyof typeof emailTemplates]) {
//       const template = emailTemplates[templateKey as keyof typeof emailTemplates]
//       setSubject(template.subject)
//       setMessage(template.body)
//     }
//   }

//   const handleSend = async () => {
//     if (!subject.trim() || !message.trim()) {
//       setError("Please fill in both subject and message")
//       return
//     }

//     setSending(true)
//     setError("")

//     try {
//       await onSendEmail({
//         recipients: recipients.map((r) => ({
//           email: r.email_address,
//           name: r.full_name,
//           userId: r.user_id,
//         })),
//         subject,
//         message,
//         template,
//         projectId: project?.project_id,
//         jobRoleId: selectedRole?.jobRoleID,
//       })

//       setSubject("")
//       setMessage("")
//       setTemplate("")
//       onClose()
//     } catch (err) {
//       setError("Failed to send email. Please try again.")
//     } finally {
//       setSending(false)
//     }
//   }

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth className={styles.emailDialog}>
//       <DialogTitle className={styles.dialogTitle}>
//         <Box className={styles.titleHeader}>
//           <Typography variant="h6">
//             Compose Email - {position} ({recipients.length} recipient{recipients.length !== 1 ? "s" : ""})
//           </Typography>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent className={styles.dialogContent}>
//         {error && (
//           <Alert severity="error" className={styles.errorAlert}>
//             {error}
//           </Alert>
//         )}

//         <Box className={styles.recipientsSection}>
//           <Typography variant="body2" className={styles.recipientsLabel}>
//             Recipients:
//           </Typography>
//           <Box className={styles.recipientsContainer}>
//             {recipients.map((recipient, index) => (
//               <Chip
//                 key={index}
//                 label={`${recipient.full_name} (${recipient.email_address})`}
//                 size="small"
//                 className={styles.recipientChip}
//               />
//             ))}
//           </Box>
//         </Box>

//         <FormControl fullWidth className={styles.templateSelect}>
//           <InputLabel>Email Template</InputLabel>
//           <Select value={template} onChange={(e) => handleTemplateChange(e.target.value)} label="Email Template">
//             <MenuItem value="">Custom Email</MenuItem>
//             <MenuItem value="application_received">Application Received</MenuItem>
//             <MenuItem value="interview_invitation">Interview Invitation</MenuItem>
//             <MenuItem value="rejection">Application Update</MenuItem>
//           </Select>
//         </FormControl>

//         <TextField
//           fullWidth
//           label="Subject"
//           value={subject}
//           onChange={(e) => setSubject(e.target.value)}
//           className={styles.subjectField}
//           placeholder="Enter email subject..."
//         />

//         <TextField
//           fullWidth
//           multiline
//           rows={12}
//           label="Message"
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//           className={styles.messageField}
//           placeholder="Enter your message..."
//         />

//         <Box className={styles.templateNote}>
//           <Typography variant="caption" color="text.secondary">
//             Use {`{{ name }}`} in your message for personalization. Position: {String(position)}
//           </Typography>
//         </Box>
//       </DialogContent>

//       <DialogActions className={styles.dialogActions}>
//         <Button variant="outlined" startIcon={<AttachFileIcon />} disabled={sending}>
//           Attach Files
//         </Button>
//         <Button
//           variant="contained"
//           onClick={handleSend}
//           disabled={sending || !subject.trim() || !message.trim()}
//           startIcon={sending ? <CircularProgress size={16} /> : <SendIcon />}
//         >
//           {sending ? "Sending..." : "Send Email"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   )
// }

// export default EmailComposer

import React from "react"
import { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress,
} from "@mui/material"
import { Close as CloseIcon, Send as SendIcon, AttachFile as AttachFileIcon } from "@mui/icons-material"
import styles from "./EmailComposer.module.css"

interface EmailComposerProps {
  open: boolean
  onClose: () => void
  recipients: any[]
  project?: any
  selectedRole?: any
}

const EmailComposer: React.FC<EmailComposerProps> = ({ open, onClose, recipients, project, selectedRole }) => {
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")
  const [template, setTemplate] = useState("")
  const [sending, setSending] = useState(false)
  const [error, setError] = useState("")

  const position =
    typeof selectedRole?.jobTitle === "string"
      ? selectedRole.jobTitle
      : selectedRole?.jobTitle?.name ||
        (typeof project?.project_name === "string" ? project.project_name : project?.project_name?.name) ||
        "Position"

  const projectName =
    typeof project?.project_name === "string" ? project.project_name : project?.project_name?.name || "Our Company"

  const emailTemplates = {
    interview_invitation: {
      subject: `Interview Invitation - ${position}`,
      body: `Dear ${recipients.length === 1 ? recipients[0].full_name : "Applicant"},

Thank you for your interest in the ${position} position at ${projectName}. We were impressed with your application and would like to invite you for an interview.

Please let us know your availability for the coming week, and we'll schedule a convenient time.

Best regards,
Hiring Team`,
    },
    application_received: {
      subject: `Application Received - ${position}`,
      body: `Dear ${recipients.length === 1 ? recipients[0].full_name : "Applicant"},

Thank you for applying for the ${position} position at ${projectName}. We have received your application and will review it carefully.

We will contact you within the next few days regarding the next steps in our hiring process.

Best regards,
Hiring Team`,
    },
    rejection: {
      subject: `Update on Your Application - ${position}`,
      body: `Dear ${recipients.length === 1 ? recipients[0].full_name : "Applicant"},

Thank you for your interest in the ${position} position at ${projectName} and for taking the time to apply.

After careful consideration, we have decided to move forward with other candidates whose experience more closely matches our current needs.

We appreciate your interest in our company and encourage you to apply for future opportunities.

Best regards,
Hiring Team`,
    },
  }

  const handleTemplateChange = (templateKey: string) => {
    setTemplate(templateKey)
    if (templateKey && emailTemplates[templateKey as keyof typeof emailTemplates]) {
      const template = emailTemplates[templateKey as keyof typeof emailTemplates]
      setSubject(template.subject)
      setMessage(template.body)
    }
  }

  const handleSend = () => {
    if (!subject.trim() || !message.trim()) {
      setError("Please fill in both subject and message")
      return
    }

    setSending(true)
    setError("")

    try {
      // Create comma-separated list of email addresses
      const emailAddresses = recipients.map((r) => r.email_address).join(",")

      // Personalize message based on number of recipients
      let personalizedMessage = message
      if (recipients.length === 1) {
        // Single recipient - personalize with their name
        personalizedMessage = message.replace(/\{\{name\}\}/g, recipients[0].full_name)
      } else {
        // Multiple recipients - use generic greeting
        personalizedMessage = message.replace(/\{\{name\}\}/g, "Applicant")
      }

      // URL encode the subject and body for mailto
      const encodedSubject = encodeURIComponent(subject)
      const encodedBody = encodeURIComponent(personalizedMessage)

      // Construct mailto URL
      const mailtoUrl = `mailto:${emailAddresses}?subject=${encodedSubject}&body=${encodedBody}`

      // Open default email client
      window.open(mailtoUrl)

      // Reset form and close dialog
      setSubject("")
      setMessage("")
      setTemplate("")
      onClose()
    } catch (err) {
      setError("Failed to open email client. Please try again.")
    } finally {
      setSending(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth className={styles.emailDialog}>
      <DialogTitle className={styles.dialogTitle}>
        <Box className={styles.titleHeader}>
          <Typography variant="h6">
            Compose Email - {position} ({recipients.length} recipient{recipients.length !== 1 ? "s" : ""})
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>
        {error && (
          <Alert severity="error" className={styles.errorAlert}>
            {error}
          </Alert>
        )}

        <Box className={styles.recipientsSection}>
          <Typography variant="body2" className={styles.recipientsLabel}>
            Recipients:
          </Typography>
          <Box className={styles.recipientsContainer}>
            {recipients.map((recipient, index) => (
              <Chip
                key={index}
                label={`${recipient.full_name} (${recipient.email_address})`}
                size="small"
                className={styles.recipientChip}
              />
            ))}
          </Box>
        </Box>

        <FormControl fullWidth className={styles.templateSelect}>
          <InputLabel>Email Template</InputLabel>
          <Select value={template} onChange={(e) => handleTemplateChange(e.target.value)} label="Email Template">
            <MenuItem value="">Custom Email</MenuItem>
            <MenuItem value="application_received">Application Received</MenuItem>
            <MenuItem value="interview_invitation">Interview Invitation</MenuItem>
            <MenuItem value="rejection">Application Update</MenuItem>
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          className={styles.subjectField}
          placeholder="Enter email subject..."
        />

        <TextField
          fullWidth
          multiline
          rows={12}
          label="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className={styles.messageField}
          placeholder="Enter your message..."
        />

        <Box className={styles.templateNote}>
          <Typography variant="caption" color="text.secondary">
            {/* Use {`{{ name }}`} in your message for personalization. Position: {String(position)} */}
            Use {recipients.map((r) => `{{ ${r.full_name} }}`).join(", ")} in your message for personalization. Position: {String(position)}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions className={styles.dialogActions}>
        <Button variant="outlined" startIcon={<AttachFileIcon />} disabled={sending}>
          Attach Files
        </Button>
        <Button
          variant="contained"
          onClick={handleSend}
          disabled={sending || !subject.trim() || !message.trim()}
          startIcon={sending ? <CircularProgress size={16} /> : <SendIcon />}
        >
          {sending ? "Sending..." : "Send Email"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EmailComposer

